import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function SupabaseTest() {
  const [testResult, setTestResult] = useState<string>('')
  const [loading, setLoading] = useState(false)

  const testConnection = async () => {
    setLoading(true)
    setTestResult('🔄 Testando conexão...')
    
    try {
      // Teste 1: Verificar configuração
      const url = import.meta.env.VITE_SUPABASE_URL
      const key = import.meta.env.VITE_SUPABASE_ANON_KEY
      
      console.log('🔧 Configuração:')
      console.log('URL:', url)
      console.log('Key:', key ? `${key.substring(0, 20)}...` : 'FALTANDO')
      
      if (!url || !key) {
        setTestResult('❌ Variáveis de ambiente faltando!')
        return
      }
      
      // Teste 2: Verificar conexão com Supabase
      const { data, error } = await supabase.auth.getSession()
      console.log('📡 Sessão atual:', data)
      
      if (error) {
        setTestResult(`❌ Erro na conexão: ${error.message}`)
        return
      }
      
      // Teste 3: Tentar operação simples
      const { data: testData, error: testError } = await supabase
        .from('profiles')
        .select('count')
        .limit(1)
      
      console.log('🗄️ Teste de query:', testData, testError)
      
      // Teste 4: Tentar cadastro de teste
      const testEmail = `teste-${Date.now()}@test.com`
      console.log('🧪 Testando cadastro com:', testEmail)
      
      const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
        email: testEmail,
        password: '123456'
      })
      
      console.log('📝 Resultado do cadastro:', signUpData, signUpError)
      
      if (signUpError) {
        setTestResult(`❌ Erro no cadastro: ${signUpError.message}`)
      } else {
        setTestResult(`✅ Teste concluído! Usuário criado: ${signUpData.user?.id}`)
      }
      
    } catch (error) {
      console.error('💥 Erro inesperado:', error)
      setTestResult(`💥 Erro inesperado: ${error}`)
    } finally {
      setLoading(false)
    }
  }

  const testProfile = async () => {
    setLoading(true)
    setTestResult('🔄 Testando criação de perfil...')
    
    try {
      const testUserId = 'test-' + Date.now()
      const { data, error } = await supabase
        .from('profiles')
        .insert({
          user_id: testUserId,
          email: 'test@test.com',
          username: 'test_user'
        })
        .select()
      
      console.log('👤 Teste de perfil:', data, error)
      
      if (error) {
        setTestResult(`❌ Erro ao criar perfil: ${error.message}`)
      } else {
        setTestResult(`✅ Perfil criado com sucesso!`)
      }
      
    } catch (error) {
      console.error('💥 Erro no teste de perfil:', error)
      setTestResult(`💥 Erro no teste de perfil: ${error}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="card p-6 max-w-2xl mx-auto">
      <h2 className="text-xl font-bold mb-4">🧪 Teste de Conexão Supabase</h2>
      
      <div className="space-y-4">
        <button
          onClick={testConnection}
          disabled={loading}
          className="btn-primary w-full"
        >
          {loading ? '🔄 Testando...' : '🧪 Testar Cadastro Completo'}
        </button>
        
        <button
          onClick={testProfile}
          disabled={loading}
          className="btn-ghost w-full"
        >
          {loading ? '🔄 Testando...' : '👤 Testar Apenas Perfil'}
        </button>
        
        {testResult && (
          <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
            <pre className="text-sm whitespace-pre-wrap">{testResult}</pre>
          </div>
        )}
        
        <div className="text-sm text-gray-600 dark:text-gray-400">
          <p>📋 <strong>Instruções:</strong></p>
          <p>1. Abra o Console (F12)</p>
          <p>2. Clique no botão de teste</p>
          <p>3. Observe os logs detalhados</p>
          <p>4. Reporte os resultados</p>
        </div>
      </div>
    </div>
  )
}
